import { useQuery } from '@tanstack/react-query';

import { getAffiliationList } from '~/services/AgentHub/AgentService';

const FIVE_MINUTES = 5 * 60 * 1000;

export function useGetAffiliationList(regionCode: string | undefined) {
  return useQuery({
    queryKey: ['affiliation-list', regionCode],
    queryFn: async () => {
      return await getAffiliationList(regionCode);
    },
    enabled: !!regionCode,
    staleTime: FIVE_MINUTES,
  });
}
